export default __webpack_public_path__ + "static/media/loginEdu.b5992b66.png";